define('data/index',[
	'./london'
], function () {
	return [
		arguments[0]
	];
});
